import React from 'react';
import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';
import { getNextgenSettingsUrl } from '@atlassian/jira-project-settings-apps-common/src/urls.tsx';
import { type BaseUrl, toBaseUrl } from '@atlassian/jira-shared-types/src/general.tsx';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';

export type AutomationPageType = 'summary' | 'edit' | 'copy' | 'create' | 'viewlog';

const newAutomationUrl = (
	baseUrl: BaseUrl,
	{ match }: RouteContext,
	pageType: AutomationPageType,
) => {
	const { projectKey } = match.params;
	if (pageType === 'edit') {
		const { ruleId } = match.params;
		return `${getNextgenSettingsUrl(SERVICE_DESK_PROJECT, String(projectKey))}/automation/ruleset/${ruleId || ''}`;
	}
	if (pageType === 'copy') {
		const { ruleId } = match.params;
		return `${getNextgenSettingsUrl(SERVICE_DESK_PROJECT, String(projectKey))}/automation/copy/${ruleId || ''}`;
	}
	if (pageType === 'viewlog') {
		const { ruleId } = match.params;
		return `${getNextgenSettingsUrl(SERVICE_DESK_PROJECT, String(projectKey))}/automation/log/${ruleId || ''}`;
	}
	if (pageType === 'create') {
		const { blueprintKey } = match.params;
		return `${getNextgenSettingsUrl(SERVICE_DESK_PROJECT, String(projectKey))}/automation/blueprint/${blueprintKey || ''}`;
	}
	return `${getNextgenSettingsUrl(SERVICE_DESK_PROJECT, String(projectKey))}/automation`;
};

/**
 * Higher order component that generates a redirect to a specific route
 * These redirects to not push to history
 *
 * Currently this is used to redirect existing routes to the new automation routes
 */
export const automationRedirect =
	(pageType: AutomationPageType) => (routeContext: RouteContext) => {
		// use empty string instead of actual baseUrl as router redirect handles it internally
		const emptyBaseUrl = toBaseUrl('');
		return <Redirect to={newAutomationUrl(emptyBaseUrl, routeContext, pageType)} push={false} />;
	};
